"use strict";
var TicketsService_1;
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketsService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const typeorm_2 = require("typeorm");
const crypto_1 = require("crypto");
const service_ticket_entity_1 = require("./service-ticket.entity");
const ticket_evidence_entity_1 = require("./ticket-evidence.entity");
const user_entity_1 = require("../users/user.entity");
let TicketsService = TicketsService_1 = class TicketsService {
    constructor(ticketRepo, evidenceLinkRepo) {
        this.ticketRepo = ticketRepo;
        this.evidenceLinkRepo = evidenceLinkRepo;
        this.logger = new common_1.Logger(TicketsService_1.name);
    }
    // â”€â”€ Evidence link management â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    async generateEvidenceLink(ticketId, frontendUrl) {
        // Reuse existing link if not expired
        const existing = await this.evidenceLinkRepo.findOne({ where: { ticketId } });
        if (existing && (!existing.expiresAt || existing.expiresAt > new Date())) {
            return existing;
        }
        const token = (0, crypto_1.randomUUID)().replace(/-/g, '');
        const expiresAt = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000); // 7 days
        const link = this.evidenceLinkRepo.create({
            ticket: { id: ticketId },
            ticketId,
            token,
            expiresAt,
            files: [],
            uploadComplete: false,
        });
        return this.evidenceLinkRepo.save(link);
    }
    async getEvidenceLink(ticketId) {
        return this.evidenceLinkRepo.findOne({ where: { ticketId } });
    }
    async getEvidenceByToken(token) {
        return this.evidenceLinkRepo.findOne({ where: { token }, relations: ['ticket'] });
    }
    /** Called after agent reviews evidence and sets logistics priority */
    async setEvidencePriority(ticketId, priority, logisticsComment) {
        const ticket = await this.findById(ticketId);
        ticket.priority = priority;
        if (logisticsComment) {
            ticket.teamLeadRemarks = logisticsComment;
        }
        return this.ticketRepo.save(ticket);
    }
    findAll(customerId, status) {
        const where = {};
        if (customerId)
            where.customer = { id: customerId };
        if (status)
            where.status = status;
        return this.ticketRepo.find({
            where,
            relations: ['customer', 'createdBy', 'assignedTo', 'relatedOrder'],
            order: { createdAt: 'DESC' },
        });
    }
    async findById(id) {
        const ticket = await this.ticketRepo.findOne({
            where: { id },
            relations: ['customer', 'createdBy', 'assignedTo', 'relatedOrder'],
        });
        if (!ticket)
            throw new common_1.NotFoundException(`Ticket #${id} not found`);
        return ticket;
    }
    async create(dto) {
        const year = new Date().getFullYear();
        const count = await this.ticketRepo.count();
        const seq = String(count + 1).padStart(5, '0');
        const ticketNumber = `TKT-${year}-${seq}`;
        // Major/Critical side effects â†’ auto-urgent
        const priority = dto.severity === service_ticket_entity_1.TicketSeverity.MAJOR_CRITICAL
            ? service_ticket_entity_1.TicketPriority.URGENT
            : dto.priority;
        const ticket = this.ticketRepo.create({
            ticketNumber,
            customer: { id: dto.customerId },
            relatedOrder: dto.orderId ? { id: dto.orderId } : undefined,
            ticketType: dto.ticketType,
            description: dto.description,
            priority,
            severity: dto.severity,
            createdBy: { id: dto.createdById },
            evidenceUrls: dto.evidenceUrls ?? [],
            status: service_ticket_entity_1.TicketStatus.OPEN,
            workflowStage: service_ticket_entity_1.WorkflowStage.OPEN,
        });
        return this.ticketRepo.save(ticket);
    }
    /**
     * Central workflow transition â€” enforces valid stage progressions per ticket type.
     * The frontend calls this with an action string; the service validates and applies it.
     */
    async transition(id, action, payload = {}, actor) {
        const t = await this.findById(id);
        switch (action) {
            // â”€â”€ LOGISTICS - NOT RECEIVED â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
            case 'start_investigation':
                this.assertType(t, [service_ticket_entity_1.TicketType.LOGISTICS_NOT_RECEIVED, service_ticket_entity_1.TicketType.LOGISTICS_FOLLOWUP]);
                t.status = service_ticket_entity_1.TicketStatus.IN_PROGRESS;
                t.workflowStage = service_ticket_entity_1.WorkflowStage.CHECKING_ORDER;
                break;
            case 'share_with_logistics':
                this.assertStage(t, [service_ticket_entity_1.WorkflowStage.CHECKING_ORDER, service_ticket_entity_1.WorkflowStage.VERIFYING_CLAIM]);
                t.status = service_ticket_entity_1.TicketStatus.WITH_LOGISTICS;
                t.workflowStage = service_ticket_entity_1.WorkflowStage.SHARED_LOGISTICS;
                if (payload.remarks)
                    t.teamLeadRemarks = payload.remarks;
                break;
            case 'remind_logistics':
                this.assertStage(t, [service_ticket_entity_1.WorkflowStage.SHARED_LOGISTICS]);
                if (payload.remarks) {
                    const reminderNote = `[Logistics reminder ${new Date().toISOString()}] ${payload.remarks}`;
                    t.teamLeadRemarks = t.teamLeadRemarks
                        ? `${t.teamLeadRemarks}\n${reminderNote}`
                        : reminderNote;
                }
                break;
            // â”€â”€ LOGISTICS - DAMAGED / WRONG â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
            case 'collect_evidence':
                // Advance to evidence_link_sent â€” actual link generated by controller
                this.assertType(t, [service_ticket_entity_1.TicketType.LOGISTICS_DAMAGED, service_ticket_entity_1.TicketType.DAMAGED_ORDER]);
                if (t.workflowStage === service_ticket_entity_1.WorkflowStage.EVIDENCE_LINK_SENT)
                    break; // idempotent
                t.status = service_ticket_entity_1.TicketStatus.IN_PROGRESS;
                t.workflowStage = service_ticket_entity_1.WorkflowStage.EVIDENCE_LINK_SENT;
                break;
            case 'mark_evidence_received':
                // Agent has reviewed the uploaded files â€” advance to verifying
                this.assertStage(t, [service_ticket_entity_1.WorkflowStage.EVIDENCE_LINK_SENT, service_ticket_entity_1.WorkflowStage.EVIDENCE_COLLECTED]);
                t.workflowStage = service_ticket_entity_1.WorkflowStage.VERIFYING_CLAIM;
                break;
            case 'start_verification':
                this.assertStage(t, [service_ticket_entity_1.WorkflowStage.EVIDENCE_LINK_SENT, service_ticket_entity_1.WorkflowStage.EVIDENCE_COLLECTED, service_ticket_entity_1.WorkflowStage.VERIFYING_CLAIM]);
                t.workflowStage = service_ticket_entity_1.WorkflowStage.VERIFYING_CLAIM;
                break;
            case 'set_claim_validity':
                this.assertStage(t, [service_ticket_entity_1.WorkflowStage.VERIFYING_CLAIM]);
                t.claimVerified = payload.isValid ?? false;
                if (payload.isValid) {
                    // Valid â†’ share with logistics for re-dispatch
                    t.status = service_ticket_entity_1.TicketStatus.WITH_LOGISTICS;
                    t.workflowStage = service_ticket_entity_1.WorkflowStage.SHARED_LOGISTICS;
                }
                else {
                    // Invalid â†’ inform patient and close
                    t.status = service_ticket_entity_1.TicketStatus.RESOLVED;
                    t.workflowStage = service_ticket_entity_1.WorkflowStage.CLOSED;
                    t.finalRemarks = payload.remarks ?? 'Claim found invalid after investigation. Patient informed.';
                    t.resolvedAt = new Date();
                }
                break;
            case 'send_to_refund_queue':
                this.assertRoles(actor, [user_entity_1.UserRole.LOGISTICS]);
                this.assertStage(t, [service_ticket_entity_1.WorkflowStage.SHARED_LOGISTICS]);
                t.status = service_ticket_entity_1.TicketStatus.WITH_MANAGEMENT;
                t.workflowStage = service_ticket_entity_1.WorkflowStage.WITH_MANAGEMENT;
                t.escalatedToManagementAt = new Date();
                if (payload.remarks) {
                    const refundNote = `[Sent to refund queue by logistics] ${payload.remarks}`;
                    t.managementRemarks = t.managementRemarks
                        ? `${t.managementRemarks}\n${refundNote}`
                        : refundNote;
                }
                break;
            // â”€â”€ SIDE EFFECT / NO RESULT â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
            case 'collect_history':
                this.assertType(t, [service_ticket_entity_1.TicketType.SIDE_EFFECT, service_ticket_entity_1.TicketType.NO_RESULT]);
                t.status = service_ticket_entity_1.TicketStatus.IN_PROGRESS;
                t.workflowStage = service_ticket_entity_1.WorkflowStage.HISTORY_COLLECTED;
                if (payload.remarks)
                    t.description = t.description + '\n\n[History]: ' + payload.remarks;
                break;
            case 'share_with_doctor':
                this.assertStage(t, [service_ticket_entity_1.WorkflowStage.HISTORY_COLLECTED, service_ticket_entity_1.WorkflowStage.OPEN]);
                t.status = service_ticket_entity_1.TicketStatus.WITH_DOCTOR;
                t.workflowStage = service_ticket_entity_1.WorkflowStage.WITH_DOCTOR;
                t.doctorTeamSharedAt = new Date();
                break;
            case 'doctor_outcome':
                this.assertStage(t, [service_ticket_entity_1.WorkflowStage.WITH_DOCTOR]);
                if (payload.doctorRemarks)
                    t.doctorRemarks = payload.doctorRemarks;
                if (payload.satisfied) {
                    t.status = service_ticket_entity_1.TicketStatus.RESOLVED;
                    t.workflowStage = service_ticket_entity_1.WorkflowStage.RESOLVED;
                    t.finalRemarks = payload.doctorRemarks ?? 'Patient satisfied after doctor consultation.';
                    t.resolvedAt = new Date();
                }
                else {
                    // Dissatisfied â†’ escalate to team lead
                    t.status = service_ticket_entity_1.TicketStatus.WITH_TEAM_LEAD;
                    t.workflowStage = service_ticket_entity_1.WorkflowStage.WITH_TEAM_LEAD;
                    t.escalatedToTeamLeadAt = new Date();
                    if (payload.teamLeadId)
                        t.assignedTo = { id: payload.teamLeadId };
                }
                break;
            // â”€â”€ REFUND / RETURN / EXCHANGE / REGISTRATION CANCEL â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
            case 'collect_refund_info':
                this.assertType(t, [
                    service_ticket_entity_1.TicketType.REFUND_REQUEST,
                    service_ticket_entity_1.TicketType.RETURN_EXCHANGE,
                    service_ticket_entity_1.TicketType.REGISTRATION_CANCEL,
                ]);
                t.status = service_ticket_entity_1.TicketStatus.IN_PROGRESS;
                t.workflowStage = service_ticket_entity_1.WorkflowStage.HISTORY_COLLECTED;
                if (payload.remarks)
                    t.description = t.description + '\n\n[Collected]: ' + payload.remarks;
                break;
            case 'refund_share_doctor':
                // Medicine issues path â€” goes to doctor first
                this.assertType(t, [service_ticket_entity_1.TicketType.REFUND_REQUEST]);
                this.assertStage(t, [service_ticket_entity_1.WorkflowStage.HISTORY_COLLECTED, service_ticket_entity_1.WorkflowStage.OPEN]);
                t.status = service_ticket_entity_1.TicketStatus.WITH_DOCTOR;
                t.workflowStage = service_ticket_entity_1.WorkflowStage.WITH_DOCTOR;
                t.doctorTeamSharedAt = new Date();
                break;
            case 'escalate_team_lead':
                // Used after doctor unsatisfied, or directly for return/registration cancel
                this.assertStage(t, [
                    service_ticket_entity_1.WorkflowStage.HISTORY_COLLECTED,
                    service_ticket_entity_1.WorkflowStage.WITH_DOCTOR,
                    service_ticket_entity_1.WorkflowStage.VERIFYING_CLAIM,
                    service_ticket_entity_1.WorkflowStage.OPEN,
                ]);
                t.status = service_ticket_entity_1.TicketStatus.WITH_TEAM_LEAD;
                t.workflowStage = service_ticket_entity_1.WorkflowStage.WITH_TEAM_LEAD;
                t.escalatedToTeamLeadAt = new Date();
                if (payload.teamLeadId)
                    t.assignedTo = { id: payload.teamLeadId };
                if (payload.remarks)
                    t.teamLeadRemarks = payload.remarks;
                break;
            case 'team_lead_outcome':
                this.assertStage(t, [service_ticket_entity_1.WorkflowStage.WITH_TEAM_LEAD]);
                if (payload.remarks)
                    t.teamLeadRemarks = payload.remarks;
                if (payload.satisfied) {
                    t.status = service_ticket_entity_1.TicketStatus.RESOLVED;
                    t.workflowStage = service_ticket_entity_1.WorkflowStage.RESOLVED;
                    t.finalRemarks = payload.remarks ?? 'Resolved at team lead level.';
                    t.resolvedAt = new Date();
                }
                else {
                    t.status = service_ticket_entity_1.TicketStatus.WITH_MANAGEMENT;
                    t.workflowStage = service_ticket_entity_1.WorkflowStage.WITH_MANAGEMENT;
                    t.escalatedToManagementAt = new Date();
                }
                break;
            case 'management_outcome':
                this.assertStage(t, [service_ticket_entity_1.WorkflowStage.WITH_MANAGEMENT]);
                if (payload.remarks)
                    t.managementRemarks = payload.remarks;
                if (payload.satisfied) {
                    t.status = service_ticket_entity_1.TicketStatus.RESOLVED;
                    t.workflowStage = service_ticket_entity_1.WorkflowStage.RESOLVED;
                    t.finalRemarks = payload.remarks ?? 'Resolved at management level.';
                    t.resolvedAt = new Date();
                }
                else {
                    // Not satisfied â†’ refund
                    t.status = service_ticket_entity_1.TicketStatus.REFUNDED;
                    t.workflowStage = service_ticket_entity_1.WorkflowStage.REFUNDED;
                    t.refundAmount = payload.refundAmount ?? 0;
                    t.finalRemarks = payload.remarks ?? 'Refund approved by management.';
                    t.resolvedAt = new Date();
                }
                break;
            // â”€â”€ FEEDBACK â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
            case 'share_feedback_form':
                this.assertType(t, [service_ticket_entity_1.TicketType.FEEDBACK]);
                t.feedbackFormShared = true;
                t.status = service_ticket_entity_1.TicketStatus.IN_PROGRESS;
                t.workflowStage = service_ticket_entity_1.WorkflowStage.FORM_SHARED;
                break;
            case 'send_reminder':
                this.assertStage(t, [service_ticket_entity_1.WorkflowStage.FORM_SHARED]);
                // Stage stays the same â€” just records that reminder was sent
                if (payload.remarks)
                    t.description = t.description + '\n[Reminder sent]';
                break;
            case 'mark_form_filled':
                this.assertStage(t, [service_ticket_entity_1.WorkflowStage.FORM_SHARED]);
                t.feedbackFormFilled = true;
                t.feedbackSentiment = payload.sentiment;
                t.workflowStage = service_ticket_entity_1.WorkflowStage.FORM_FILLED;
                if (payload.sentiment === service_ticket_entity_1.FeedbackSentiment.NEGATIVE) {
                    // Negative â†’ escalate to management
                    t.status = service_ticket_entity_1.TicketStatus.WITH_MANAGEMENT;
                    t.workflowStage = service_ticket_entity_1.WorkflowStage.WITH_MANAGEMENT;
                    t.escalatedToManagementAt = new Date();
                    if (payload.remarks)
                        t.description = t.description + '\n\n[Negative Feedback]: ' + payload.remarks;
                }
                else {
                    // Positive â†’ request video review
                    t.status = service_ticket_entity_1.TicketStatus.IN_PROGRESS;
                    t.workflowStage = service_ticket_entity_1.WorkflowStage.FORM_FILLED;
                }
                break;
            case 'request_video_review':
                this.assertStage(t, [service_ticket_entity_1.WorkflowStage.FORM_FILLED]);
                t.workflowStage = service_ticket_entity_1.WorkflowStage.VIDEO_REQUESTED;
                break;
            case 'close_feedback':
                this.assertType(t, [service_ticket_entity_1.TicketType.FEEDBACK]);
                t.status = service_ticket_entity_1.TicketStatus.CLOSED;
                t.workflowStage = service_ticket_entity_1.WorkflowStage.CLOSED;
                t.finalRemarks = payload.remarks ?? 'Feedback cycle complete.';
                t.resolvedAt = new Date();
                break;
            case 'add_management_remarks_feedback':
                this.assertStage(t, [service_ticket_entity_1.WorkflowStage.WITH_MANAGEMENT]);
                t.managementRemarks = payload.remarks ?? '';
                t.status = service_ticket_entity_1.TicketStatus.CLOSED;
                t.workflowStage = service_ticket_entity_1.WorkflowStage.CLOSED;
                t.finalRemarks = payload.remarks ?? '';
                t.resolvedAt = new Date();
                break;
            // â”€â”€ RESOLVED (logistics - shared with logistics, patient msg sent) â”€â”€
            case 'resolve_logistics':
                this.assertRoles(actor, [user_entity_1.UserRole.LOGISTICS]);
                this.assertStage(t, [service_ticket_entity_1.WorkflowStage.SHARED_LOGISTICS]);
                t.status = service_ticket_entity_1.TicketStatus.RESOLVED;
                t.workflowStage = service_ticket_entity_1.WorkflowStage.RESOLVED;
                t.finalRemarks = payload.remarks ?? 'Resolved by logistics team.';
                t.resolvedAt = new Date();
                break;
            default:
                throw new common_1.BadRequestException(`Unknown workflow action: ${action}`);
        }
        return this.ticketRepo.save(t);
    }
    // â”€â”€ legacy helpers (keep for backward compat) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    async updateStatus(id, status, remarks) {
        const ticket = await this.findById(id);
        ticket.status = status;
        if (remarks)
            ticket.managementRemarks = remarks;
        return this.ticketRepo.save(ticket);
    }
    async escalateToTeamLead(id, teamLeadId) {
        const ticket = await this.findById(id);
        ticket.status = service_ticket_entity_1.TicketStatus.WITH_TEAM_LEAD;
        ticket.workflowStage = service_ticket_entity_1.WorkflowStage.WITH_TEAM_LEAD;
        ticket.assignedTo = { id: teamLeadId };
        ticket.escalatedToTeamLeadAt = new Date();
        return this.ticketRepo.save(ticket);
    }
    async escalateToManagement(id) {
        const ticket = await this.findById(id);
        ticket.status = service_ticket_entity_1.TicketStatus.WITH_MANAGEMENT;
        ticket.workflowStage = service_ticket_entity_1.WorkflowStage.WITH_MANAGEMENT;
        ticket.escalatedToManagementAt = new Date();
        return this.ticketRepo.save(ticket);
    }
    async resolve(id, finalRemarks, resolvedById) {
        const ticket = await this.findById(id);
        ticket.status = service_ticket_entity_1.TicketStatus.RESOLVED;
        ticket.workflowStage = service_ticket_entity_1.WorkflowStage.RESOLVED;
        ticket.finalRemarks = finalRemarks;
        ticket.resolvedAt = new Date();
        ticket.assignedTo = { id: resolvedById };
        return this.ticketRepo.save(ticket);
    }
    // â”€â”€ private helpers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    assertType(ticket, types) {
        if (!types.includes(ticket.ticketType)) {
            throw new common_1.BadRequestException(`This action is not valid for ticket type "${ticket.ticketType}"`);
        }
    }
    assertStage(ticket, stages) {
        if (!stages.includes(ticket.workflowStage)) {
            throw new common_1.BadRequestException(`Cannot perform this action at stage "${ticket.workflowStage}"`);
        }
    }
    assertRoles(actor, roles) {
        const currentRole = `${actor?.role ?? ''}`.toLowerCase();
        const allowed = roles.map((role) => role.toLowerCase());
        if (!allowed.includes(currentRole)) {
            throw new common_1.BadRequestException('This action is only allowed for the designated role queue.');
        }
    }
};
exports.TicketsService = TicketsService;
exports.TicketsService = TicketsService = TicketsService_1 = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__param(0, (0, typeorm_1.InjectRepository)(service_ticket_entity_1.ServiceTicket)),
    tslib_1.__param(1, (0, typeorm_1.InjectRepository)(ticket_evidence_entity_1.TicketEvidenceLink)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _a : Object, typeof (_b = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _b : Object])
], TicketsService);
